<div class="button-container">
    <button
        class="back-button"
        data-cy="back-button"
        siriusButton
        size="large"
        iconName="arrow_left"
        iconPos="left"
        [buttonText]="text"
        [buttonType]="'secondary'"
        (click)="clickedBack()"></button>
</div>
